var _defs, _namedview;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMentors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88.942151 86.457222",
    id: "svg66",
    docname: "no-mentors.svg",
    width: 111.17769,
    height: 86.457222,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs70"
  })), _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview68",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    pageshadow: 2,
    pageopacity: 0,
    pagecheckerboard: 0,
    showgrid: "false",
    "fit-margin-top": 2.7755576e-17,
    "fit-margin-left": 2.7755576e-17,
    "fit-margin-right": 2.7755576e-17,
    "fit-margin-bottom": 2.7755576e-17,
    "lock-margins": "true",
    zoom: 4.3973203,
    cx: 47.983769,
    cy: 33.884273,
    "window-width": 1920,
    "window-height": 1011,
    "window-x": 0,
    "window-y": 0,
    "window-maximized": 1,
    "current-layer": "g1674"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1674",
    transform: "translate(52.782231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.35938,16.387885 -10.8125,0.575385 c -2.14531,-0.76718 -4.48437,-0.76718 -6.62968,0 l -44.05,15.8125 C -62.99406,16.934765 -64,18.372265 -64,19.997265 c 0,1.625 1.00594,3.07031 2.50782,3.60781 l 9.37812,3.36094 c -1.85781,2.46875 -3.16562,5.3375 -3.83594,8.42969 -1.79218,0.75781 -3.05,2.53906 -3.05,4.60156 0,1.55516 0.75219,2.88906 1.86563,3.80625 l -3.87969,23.28125 c -0.25469,1.52187 0.92031,2.9125 2.46563,2.9125 h 9.09687 c 1.54485,0 2.72031,-1.38735 2.46563,-2.91094 l -3.87969,-23.28125 C -49.75156,42.887885 -49,41.419135 -49,39.997265 c 0,-1.60781 -0.80843,-2.97344 -1.9875,-3.88906 0.66438,-2.775 2.0125,-5.28438 3.89688,-7.34844 l 29.78125,10.66094 c 2.14531,0.76718 4.48437,0.76718 6.62969,0 l 44.17187,-15.8125 C 35,23.059765 36,21.622265 36,19.997265 c 0,-1.625 -1,-3.0625 -2.64062,-3.60938 z m -42.5,27.73438 c -1.46875,0.57812 -3.15625,0.875 -4.85938,0.875 -1.70625,0 -3.38906,-0.29172 -5,-0.86797 L -41.6875,36.012885 -44,58.325385 c 0,6.45313 13.29688,11.67188 30,11.67188 16.42188,0 30,-5.21875 30,-11.66719 l -2.30937,-22.32812 z",
    id: "path64",
    style: {
      fill: "#e5e5e5",
      strokeWidth: 0.15625
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1678",
    transform: "matrix(0.94114394,0,0,0.94114394,2.7766931,5.0885318)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 4.07932,
      paintOrder: "stroke fill markers"
    },
    id: "path1543",
    cx: 22.598446,
    cy: 61.877979,
    r: 22.539581
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2.22485,62.100525 c 0,-11.13031 9.02077,-20.15108 20.15108,-20.15108 11.13032,0 20.15108,9.02077 20.15108,20.15108 0,11.13032 -9.02076,20.15108 -20.15108,20.15108 -11.13031,0 -20.15108,-9.02076 -20.15108,-20.15108 z M 16,58.330075 19.70748,62.029685 16,65.800135 c -0.73205,0.73993 -0.73205,1.9364 0,2.60548 0.73992,0.80289 1.93639,0.80289 2.60548,0 l 3.69961,-3.63664 3.77045,3.63664 c 0.73992,0.80289 1.9364,0.80289 2.60547,0 0.8029,-0.66908 0.8029,-1.86555 0,-2.60548 l -3.63664,-3.77045 3.63664,-3.69961 c 0.8029,-0.66907 0.8029,-1.86556 0,-2.60547 -0.66907,-0.73206 -1.86555,-0.73206 -2.60547,0 l -3.77045,3.70748 -3.69961,-3.70748 c -0.66909,-0.73206 -1.86556,-0.73206 -2.60548,0 -0.73205,0.73991 -0.73205,1.9364 0,2.60547 z",
    id: "path1319",
    style: {
      fill: "#ff6673",
      strokeWidth: 0.0787151
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMentors);
export default __webpack_public_path__ + "static/media/no-mentors.0050ec5e07a4f8b1369eab290daf7276.svg";
export { ForwardRef as ReactComponent };